import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { jwtDecode } from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  PermissionsEnum,
  UserDataOut,
  UserEditDataIn,
} from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-account-profile',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './account-profile.component.html',
  styleUrl: './account-profile.component.scss',
})
export class AccountProfileComponent implements OnInit {
  user: UserDataOut = new UserDataOut();
  originalUserData: UserDataOut = new UserDataOut();
  isInputShown = false;
  public PermissionsEnum = PermissionsEnum;
  userId: string | undefined;
  firstName: string = '';

  isFirstNameInputShown = false;
  isMiddleNameInputShown = false;
  isLastNameInputShown = false;
  isPhoneNumberInputShown = false;
  isAddressInputShown = false;

  constructor(
    private client: Client,
    private toastr: ToastrService,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) {
      this.userId = (jwtDecode(token) as { id: string }).id;
      this.getUser();
    }
  }

  getUser(): void {
    this.client.getMyUser().subscribe({
      next: (response) => {
        this.user = response;
        this.originalUserData = Object.assign({}, response);
        this.firstName = this.user.firstName!;
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  toggleInput(field?: string) {
    switch (field) {
      case 'firstName':
        this.isFirstNameInputShown = !this.isFirstNameInputShown;
        break;
      case 'middleName':
        this.isMiddleNameInputShown = !this.isMiddleNameInputShown;
        break;
      case 'lastName':
        this.isLastNameInputShown = !this.isLastNameInputShown;
        break;
      case 'phoneNumber':
        this.isPhoneNumberInputShown = !this.isPhoneNumberInputShown;
        break;
      case 'address':
        this.isAddressInputShown = !this.isAddressInputShown;
        break;
      case undefined:
        this.user = Object.assign({}, this.originalUserData);

        this.isFirstNameInputShown = false;
        this.isMiddleNameInputShown = false;
        this.isLastNameInputShown = false;
        this.isPhoneNumberInputShown = false;
        this.isAddressInputShown = false;
        break;
      default:
        break;
    }
  }

  saveUser(): void {
    const userEditDataIn = Object.assign(new UserEditDataIn(), {
      id: this.user.hesId,
      firstName: this.user.firstName,
      middleName: this.user.middleName,
      lastName: this.user.lastName,
      role: this.user.roleId,
      address: this.user.address,
      phoneNumber: this.user.phoneNumber,
      image: this.user.image,
    });

    this.client.editProfile(userEditDataIn).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.originalUserData = this.user;
        this.isFirstNameInputShown = false;
        this.isMiddleNameInputShown = false;
        this.isLastNameInputShown = false;
        this.isPhoneNumberInputShown = false;
        this.isAddressInputShown = false;
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
